import React from "react"
import { useTranslation } from "react-i18next"

import { useTheme } from "hooks"
import ProtectedLayout from "layouts/Protected"
import { ContactForm } from "./Partials"

import { DiscussionIcon } from "components/Elements/Icons"
import { isFrenchLanguage } from "utils/i18n"

export const ContactPage = () => {
	const { t } = useTranslation()
	const { currentTheme } = useTheme()

	const phoneNumber = isFrenchLanguage() ? currentTheme.phone : currentTheme.internationalphone

	return (
		<ProtectedLayout className="px-7 py-7">
			<div className="l-container">
				<div className="c-section-title mb-7">
					<div className="c-section-title__content justify-between">
						<div className="flex items-center justify-start w-full">
							<DiscussionIcon size={35} />
							<h1 className="c-section-title__title c-h2 text-primary font-medium ml-5">
								{t("menu.contact_support")}
							</h1>
						</div>
					</div>
				</div>
				<ContactForm />

				<section className="c-card p-5 md:p-12">
					<h2 className="c-h2 font-semibold mb-7 uppercase">
						{t("urgence_title", { ns: "contact" })}
					</h2>
					<p>{t("urgence_description", { ns: "contact", phoneNumber: phoneNumber })}</p>
				</section>
			</div>
		</ProtectedLayout>
	)
}
